import React, { Component } from 'react';
import { Alert, Button, Result, Space } from 'antd';

class WorkflowGeneratorErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      prompt: props.prompt // Store prompt in state
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Workflow Generator Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8">
          <Result
            status="error"
            title="Workflow Generation Failed"
            subTitle="There was an error generating your workflow. This could be due to complex requirements or invalid input."
            extra={[
              <Space direction="vertical" size="middle" className="w-full">
                <Alert
                  message="What you can try:"
                  description={
                    <ul className="list-disc ml-4">
                      <li>Simplify your workflow requirements</li>
                      <li>Break down complex workflows into smaller parts</li>
                      <li>Check for any invalid or unsupported requirements</li>
                      <li>Try again with more specific instructions</li>
                    </ul>
                  }
                  type="info"
                  showIcon
                />
                <div className="flex justify-center">
                  <Button 
                    type="primary" 
                    onClick={() => {
                      this.setState({ hasError: false, error: null });
                      this.props.onRetry?.(this.state.prompt); // Pass the prompt back
                    }}
                  >
                    Try Again
                  </Button>
                </div>
              </Space>
            ]}
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default WorkflowGeneratorErrorBoundary;